module.exports = __webpack_public_path__ + "static/media/german-flag-large.1199aadf.png";